import type { JSX } from "react";
import { useTranslation } from "react-i18next";

import { ConfirmDialog } from "@/shared/components/ConfirmDialog";
import { toast } from "@/shared/lib/toast";

import { useDeleteBundle } from "../api/use-delete-bundle";

interface DeleteBundleConfirmProps {
  code: string;
  onClose: () => void;
}

export function DeleteBundleConfirm({ code, onClose }: DeleteBundleConfirmProps): JSX.Element {
  const { t } = useTranslation("inventory");
  const { mutate, isPending } = useDeleteBundle();

  function handleConfirm(): void {
    mutate(code, {
      onSuccess: () => {
        toast.success(t("bundle.confirm.delete.success", { code }));
        onClose();
      },
    });
  }

  return (
    <ConfirmDialog
      title={t("bundle.confirm.delete.title")}
      description={t("bundle.confirm.delete.description", { code })}
      confirmWord="DELETE"
      confirmPlaceholder={t("bundle.confirm.delete.type_to_confirm")}
      onConfirm={handleConfirm}
      onCancel={onClose}
      isPending={isPending}
      confirmLabel={t("bundle.confirm.delete.action_delete")}
      cancelLabel={t("bundle.confirm.delete.action_cancel")}
    />
  );
}
